import { EventEmitter } from "eventemitter3";
import Hammer from "hammerjs";
export default class Mouse extends EventEmitter {
  constructor(domElement) {
    super();
    this.x = 0;
    this.y = 0;
    this.down = false;

    let mc = new Hammer(domElement);
    mc.add(new Hammer.Pan({ direction: Hammer.DIRECTION_ALL, threshold: 0 }));

    const getPosition = (e) => {
      this.x = e.center.x;
      this.y = e.center.y;
      let r = domElement.getBoundingClientRect();
      let w = r.width;
      let h = r.height;
      this.nx = this.x / w;
      this.ny = this.y / h;
    };
    mc.on("tap", (e) => {
      getPosition(e);
      this.emit("tap", e);
    });
    mc.on("press", (e) => {
      getPosition(e);
      this.down = true;
      this.emit("press", e);
    });
    mc.on("panstart", (e) => {
      getPosition(e);
      this.down = true;
      this.emit("down", e);
    });
    mc.on("panend", (e) => {
      getPosition(e);
      this.down = false;
      this.emit("up", e);
    });
    mc.on("pan", (e) => {
      getPosition(e);
      this.emit("move", e);
    });
  }
}
